// view the selected plan and checkout to stripe payment

import { Box, Button, Grid, Typography } from '@mui/material';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';
import { RootState } from '../../store';
import { BASEURL, ARROW,STRIPE_PK_KEY } from '../../constants/Common';
import FloatingButton from '../usersupport/helpdesk/FloatingButton';

declare global {
  interface Window {
    Razorpay: any; // Use 'any' for simplicity, but ideally, you should provide the correct type definition
  }
}

function SubscriptionPayment(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

  const { subscriptionData, orgfinData } = location.state;
  const orgId = useSelector((state: RootState) => state.user.userId);
  useEffect(() => {
    getProduct();
  }, []);
  const storedData = localStorage.getItem('orgid');
  let parsedData: any = null; // Define parsedData variable with 'any' type

  if (storedData) {
    parsedData = JSON.parse(storedData);
  } else {
    navigate('/login')
  }

  const subid = parsedData;

  const payload = {
    organization_id: subid,
    organization_name: orgfinData?.organization?.organization_name,
    organization_subscription_status: 'Active',
    // orgfinData?.organization?.organization_subscription_status,
    subscription_start_date: startDate,
    subscription_end_date: endDate,
    active_users_count: orgfinData?.organization?.active_users_count,
    active_project_count: orgfinData?.organization?.active_project_count,
    subscription_id: subscriptionData.id,
    user_id: orgfinData?.organization?.user_id,
  };

  const getProduct = (): void => {};
  const setSelectedItemAmounttest = subscriptionData.price;
  const setSelectedItemname = subscriptionData.title;

  const stripePromise = loadStripe(
    STRIPE_PK_KEY
  );

  const userId = useSelector((state: RootState) => state.user.userId);

  //create the order for checkout stripe page
  async function displayStripe(): Promise<void> {
    setIsButtonDisabled(true);
    try {
      const response = await axios.post(BASEURL + `/createOrder/`, {
        amount: setSelectedItemAmounttest,
        name: setSelectedItemname + ' plan',
        payload: payload,
      });

      const { checkout_session_id } = response.data;
      const stripe = await stripePromise;

      if (!stripe) {
        throw new Error('Stripe instance is null');
      }

      // Redirect to Stripe checkout page
      const checkconsole = await stripe.redirectToCheckout({
        sessionId: checkout_session_id,
      });

      // Navigate to payment success page only after successful payment
      navigate('/payment', { state: { data: subscriptionData } });
      // After successful payment, update organization data
      const updateResult = await axios.put(
        BASEURL + `/organizations/update/${subid}/`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
    } catch (error) {
      console.error('Error creating order:', error);
      setIsButtonDisabled(false);
      // Handle error
    }
  }

  const organizationData = orgfinData?.organization; // Assuming there's only one organization

  // Extract start and end dates from the organization data
  const { subscription_start_date, subscription_end_date } = organizationData;
  const today = new Date();
  const calculatedStartDate = new Date(today);
  const calculatedEndDate = new Date(calculatedStartDate);
  calculatedEndDate.setFullYear(calculatedEndDate.getFullYear() + 1);
  calculatedEndDate.setDate(calculatedEndDate.getDate() - 1);

  // Set start date and calculated end date
  useEffect(() => {
    setStartDate(calculatedStartDate.toISOString().split('T')[0]);
    setEndDate(calculatedEndDate.toISOString().split('T')[0]);
  }, []);

  return (
    <div>
      <Box sx={{ mt: '-60px' }}>
        <Box>
          <Typography variant='h6' gutterBottom>
            <Link to={'/subscriptions'}>Subscriptions</Link> {ARROW} Purchase
          </Typography>
        </Box>
        <Grid sx={{ ml: '70px', mt: '20px' }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant='subtitle1'>Selected Plan:</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='subtitle1'>
                {subscriptionData.title}
              </Typography>
            </Grid>
            <Grid item xs={6} sx={{ mt: '10px' }}>
              <Typography variant='subtitle1'>Start Date:</Typography>
            </Grid>
            <Grid item xs={6} sx={{ mt: '10px' }}>
              <Typography variant='subtitle1'>{startDate}</Typography>
            </Grid>

            <Grid item xs={6} sx={{ mt: '10px' }}>
              <Typography variant='subtitle1'>End Date:</Typography>
            </Grid>
            <Grid item xs={6} sx={{ mt: '10px' }}>
              <Typography variant='subtitle1'>{endDate}</Typography>
            </Grid>
            <Grid item xs={6} sx={{ mt: '10px' }}>
              <Typography variant='subtitle1'>Cost:</Typography>
            </Grid>
            <Grid item xs={6} sx={{ mt: '10px' }}>
              <Typography variant='subtitle1'>
                USD {subscriptionData.price}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{ display: 'flex', justifyContent: 'flex-end', mt: '20px' }}
        >
          <Button
            variant='contained'
            color='primary'
            sx={{ ml: 'auto','&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }}
            onClick={displayStripe}
            disabled={isButtonDisabled}
          >
            Make Payment
          </Button>
        </Grid>
        {/* Container for Razorpay payment form */}
        <div id='razorpay-container'></div>
      </Box>
      <FloatingButton/>
    </div>
  );
}

export default SubscriptionPayment;
